#import "../../OccupationFields.graphql"
mutation OccupationUpdate($input: OccupationUpdateInput!) {
  occupationUpdate(input: $input) {
  userOccupationTitle {
     ...OccupationFields
 }
  }
}
